import {DasqlOperation} from '../enums/dasql-operation';
import {DasqlNode} from './dasql-node';

export abstract class SingleLeafOperationDasqlNode extends DasqlNode {
  constructor(private operation: DasqlOperation, private child: DasqlNode) {
    super();
  }

  public emit(): string {
    return this.child ? `${this.operation}${this.child.emit()}` : '';
  }
}
